module.exports = __webpack_public_path__ + "img/vehicleHomeTop.da42d0ae.png";